import { createFileRoute } from "@tanstack/react-router";
import { SubPage } from "@/components/sub-page";
import acciona from "@/assets/clientes/acciona.png.asset.json";
import anglo from "@/assets/clientes/anglo.png.asset.json";
import codelco from "@/assets/clientes/codelco.png.asset.json";
import comtecsa from "@/assets/clientes/comtecsa.png.asset.json";
import geovita from "@/assets/clientes/geovita.png.asset.json";
import sigma from "@/assets/clientes/sigma.png.asset.json";
import techint from "@/assets/clientes/techint.png.asset.json";
import acreditados from "@/assets/clientes/acreditados-vp-codelco.png.asset.json";

export const Route = createFileRoute("/clientes/")({
  head: () => ({
    meta: [
      { title: "Nuestros Clientes | Mine Class" },
      { name: "description", content: "Empresas que han confiado en Mine Class." },
      { property: "og:title", content: "Nuestros Clientes | Mine Class" },
      { property: "og:description", content: "Empresas mineras que han confiado en Mine Class para capacitación, acreditación y tecnología." },
      { property: "og:url", content: "https://mine-class.com/clientes" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/clientes" }],
  }),
  component: Page,
});

const CLIENTES = [
  { name: "Codelco", src: codelco.url },
  { name: "AngloAmerican", src: anglo.url },
  { name: "Acciona", src: acciona.url },
  { name: "Techint", src: techint.url },
  { name: "Geovita", src: geovita.url },
  { name: "Sigma", src: sigma.url },
  { name: "Comtecsa", src: comtecsa.url },
  { name: "OTEC Acreditada por Codelco", src: acreditados.url },
];

function Page() {
  return (
    <SubPage
      section="clientes"
      eyebrow="Nuestros Clientes"
      title="Han confiado en nosotros"
      intro="Más de 500 empresas del sector minero en Chile, Perú y Argentina."
    >
      <section className="not-prose border border-[var(--color-outline-variant)] rounded-2xl bg-white p-6 md:p-8">
        <h3 className="text-headline-md text-[var(--color-brand-purple)] mb-6 uppercase tracking-wide">
          Confían en nosotros
        </h3>
        <div className="flex flex-wrap items-center gap-x-8 gap-y-6">
          {CLIENTES.map((c) => (
            <div key={c.name} className="flex items-center justify-center h-20 w-40 shrink-0">
              <img
                src={c.src}
                alt={c.name}
                title={c.name}
                loading="lazy"
                className="max-h-full max-w-full object-contain transition-all duration-300"
                style={{ filter: "grayscale(1)", opacity: 0.75 }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.filter = "grayscale(0)";
                  e.currentTarget.style.opacity = "1";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.filter = "grayscale(1)";
                  e.currentTarget.style.opacity = "0.75";
                }}
              />
            </div>
          ))}
        </div>
      </section>
    </SubPage>
  );
}
